module.exports = __webpack_public_path__ + "img/headset-chat.da7a156b.png";